<template>
  <div>
    <div class="authentication-modal-content">
      <VueText sizeLevel="7" weightLevel="5" color="black-100" style="margin-top: 20px;">
        {{ title }}
      </VueText>
      <VueText
        style="border: 1px solid rgba(0, 0, 0, 0.1); border-radius: 10px; margin: 15px 0; line-height: 20px; padding: 16px;"
      >
        {{ description }}
      </VueText>
    </div>
    <div v-if="isBanned" class="otp-ban-message">Çok fazla deneme yaptınız. {{ banLabel }}</div>
    <div v-if="sendError" class="otp-send-error">{{ sendError }}</div>
    <div class="authentication-modal-footer">
      <BrandButton @click="handleSendClick" :disabled="isBanned">
        <VueText>Gönder</VueText>
      </BrandButton>
    </div>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import BrandButton from '@/components/brand/BrandButton/BrandButton';
import mfa from '@/services/Api/mfa.js';

export default {
  name: 'MultiFactorAuthenticationPopup',
  components: { VueText, BrandButton },
  data() {
    return {
      isBanned: false,
      unlockDate: null,
      sendError: '',
    };
  },
  props: {
    mode: {
      type: String,
      default: 'activate',
    },
    selectedPhone: {
      type: Object,
      default: () => ({ phone: '****' }),
    },
  },
  emits: ['close', 'send'],
  computed: {
    title() {
      return this.mode === 'deactivate'
        ? 'İki Aşamalı Giriş Kapatma'
        : 'İki Aşamalı Giriş Aktifleştirme';
    },
    description() {
      return this.mode === 'deactivate'
        ? `İptal etmek için ${this.maskedPhone} ile biten telefon numarasına doğrulama kodu iletilecektir.`
        : `İki aşamalı girişi aktifleştirmek için sonu ${this.maskedPhone} biten telefon numarasına doğrulama kodu iletilecektir.`;
    },
    banLabel() {
      if (!this.unlockDate) return '';
      const diff = Math.floor((new Date(this.unlockDate) - Date.now()) / 1000 / 60);
      return `${diff} dakika sonra tekrar deneyebilirsiniz.`;
    },
    maskedPhone() {
      const phone = this.selectedPhone?.phone;
      if (!phone) return '****';
      const digits = phone.replace(/\D/g, '');
      const last4 = digits.slice(-4);
      const masked = '*'.repeat(digits.length - 4) + last4;
      return masked;
    },
  },
  methods: {
    async handleSendClick() {
      try {
        const response = await mfa.postSendCode();
        const { isBanned, unlockDate, expireDate } = response.data.Data;
        if (isBanned) {
          this.isBanned = true;
          this.unlockDate = unlockDate;
          return;
        }
        this.$emit('send', { expireDate });
      } catch (error) {
        console.error('Send code failed:', error);
        this.sendError = 'Kod gönderilemedi. Lütfen tekrar deneyin.';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.authentication-modal-content {
  width: 100%;
  padding-top: 40px;
}
.authentication-modal-footer {
  width: 100%;
  margin-top: 16px;
}
</style>
